import React from 'react';
import DataTable from '../Components/DataTable';
import FormattedDate from '../Components/FormattedDate';

function TablaEventos({ onSelectionChange, loading, error, onRetry, emptyStateNoReload, pageSize, currentPage, onPageChange, ...props }) {
    const { eventos = [] } = props;

    const columns = [
        {
            Header: 'ID',
            accessor: 'IdEvento',
        },
        {
            Header: 'Título',
            accessor: 'Titulo',
            Cell: ({ value }) => (
                <div title={value} style={{ maxWidth: '250px', fontWeight: '500' }}>
                    {value && value.length > 40 ? `${value.substring(0, 40)}...` : value}
                </div>
            )
        },
        {
            Header: 'Imagen',
            accessor: 'Url_File',
            Cell: ({ value }) => (
                <img 
                    src={value || '/favicon.png'} 
                    alt="Evento" 
                    className="avatar"
                    style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '8px' }}
                    onError={(e) => {
                        e.target.src = '/favicon.png';
                    }}
                />
            )
        },
        {
            Header: 'Fecha Creación',
            accessor: 'Fecha_creacion',
            Cell: ({ value }) => <FormattedDate date={value} format="DD/MM/YYYY" />
        },
        {
            Header: 'Fecha Fin',
            accessor: 'Fecha_fin',
            Cell: ({ value }) => <FormattedDate date={value} format="DD/MM/YYYY" />
        },
        {
            Header: 'Duración (Días)',
            accessor: 'DuracionDias',
        },
        {
            Header: 'Mes',
            accessor: 'Mes',
        },
        {
            Header: 'Ubicación',
            accessor: 'Ubicacion',
            Cell: ({ value }) => (
                <div title={value} style={{ maxWidth: '200px' }}>
                    {value && value.length > 25 ? `${value.substring(0, 25)}...` : value}
                </div>
            )
        }
    ];

    return (
        <DataTable
            data={eventos}
            columns={columns}
            idField="IdEvento"
            onSelectionChange={onSelectionChange}
            loading={loading}
            error={error}
            onRetry={onRetry}
            emptyStateNoReload={emptyStateNoReload}
            emptyMessage="Datos no encontrados"
            className="tabla-eventos"
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={onPageChange}
        />
    );
}

export default TablaEventos;